import {ajaxErrorAlert, ajaxPost} from "../utils";
import {SuccessSwal, SwalPost} from "../../app";

$(function () {
  const body = $("body");

  if (body.hasClass("domain-list")) {
    const table = $("#domainsTable");
    const form = $("#domainsFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      // rowCallback: function (nRow, aData) {
      //   $(nRow).find("td:last-of-type").append(`
      //     <a href="/gopanel/security/domains/${aData['id']}/update/" class="btn btn-sm btn-primary">Düzəliş et</a>
      //   `);
      // },
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
    });
  }

  if (
    body.hasClass("domain-list") || body.hasClass("domain-update") || body.hasClass("domain-detail")
  ) {
     $(document).on("click", ".deleteDomain", (e) => {
      e.preventDefault();
      const url = $(e.currentTarget).attr("href");
      SwalPost(
        url,
        {},
        {
          text: "Domeni silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });
  }

  if (
    body.hasClass("domain-create") ||
    body.hasClass("domain-update")
  ) {
    const form = $("#createUpdateDomainForm");

    form.on("submit", (e) => {
      e.preventDefault();

      ajaxPost("", form.serializeArray(), form)
        .then((response) => {
          SuccessSwal.fire({timer: 1000}).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }
});
